import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

interface StyleProps {
  loading?: boolean;
}

const useStyles = makeStyles<ITheme, StyleProps>((theme: ITheme) => ({
  overlayEffect: {
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: 16,
      background: ({ loading }: StyleProps) =>
        loading ? colors.disabledOverlay : 'transparent',
      transition: 'all .9s ease-out',
    },
  },
}));

export default useStyles;
